export default __webpack_public_path__ + "static/zitrone_02_mirror-3afb06ee8effdb3f3698de61cbc85572.png";